import * as React from 'react';

export interface ToastDescription {
  content: string;
  error?: boolean;
  duration?: number;
}

export interface Toast {
  show(options: ToastDescription): void;
}

export const ToastContext = React.createContext<Toast>({
  show() {},
});
